import axios from "axios";

export interface ApiErrorBody {
  message?: string;
  error?: string;
  detail?: string;
}

export function getErrorMessage(
  error: unknown,
  fallback = "An unexpected error occurred"
): string {
  if (axios.isAxiosError<ApiErrorBody>(error)) {
    return (
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.response?.data?.error ||
      error.message ||
      fallback
    );
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}
